<template>
  <div
    class="pb-icon"
    :class="editable ? 'pb-icon-editable' : 'pb-icon-readonly'"
  >
    <ColorIcon
      v-if="isColor"
      class="pb-icon-content"
      :value="value"
    />
    <Asset
      v-else
      class="pb-icon-content"
      :src="value"
    />
    <button
      v-if="editable"
      type="button"
      class="pb-icon-edit-overlay"
      @click="openDialog(preset)"
    >
      <i class="icon-edit" />
    </button>
  </div>
</template>

<script setup>
import { Color } from '@nicolaudie-group/ls-utilities'
import Asset from '@nicolaudie-group/ng-ui-kit/components/Asset/Asset.vue'
import ColorIcon from '@/components/ColorIcon/ColorIcon.vue'
import { computed } from 'vue'

const props = defineProps({
  value: { type: [Array, String, Number, Color], default: '' },
  editable: { type: Boolean, default: false },
})

const isColor = computed(() => {
  if (typeof props.value === 'string') {
    const parsed = new Color(props.value)
    if (!parsed.isValid) {
      return false
    }
  }
  return true
})
</script>

<style lang="scss" src="./PbIcon.scss" />
